module.exports = __webpack_public_path__ + "static/media/img_6.6593cce0.png";